import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../../components/ui/Button';

const GiftSuccessPage: React.FC = () => {
  const location = useLocation();
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('session_id');
    setSessionId(id);
  }, [location.search]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-xl shadow-sm p-8 text-center">
        <div className="text-4xl mb-4">🎁</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Gift purchase successful</h1>
        <p className="text-gray-600 mb-6">
          Thanks for your purchase! Your gift will be activated shortly after payment confirmation.
          You can copy and share the redemption link from your Gifts page.
        </p>
        {sessionId && (
          <p className="text-xs text-gray-400 mb-6">Checkout Session: {sessionId}</p>
        )}
        <div className="flex gap-3 justify-center">
          <Link to="/dashboard/gifts">
            <Button>View My Gifts</Button>
          </Link>
          <Button variant="outline" onClick={() => (window.location.href = '/')}>Go Home</Button>
        </div>
      </div>
    </div>
  );
};

export default GiftSuccessPage;
